import { render, staticRenderFns } from "./closeTip.vue?vue&type=template&id=75f4379c&"
import script from "./closeTip.vue?vue&type=script&lang=js&"
export * from "./closeTip.vue?vue&type=script&lang=js&"
import style0 from "./closeTip.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports